export default __webpack_public_path__ + "static/media/PLGIT_Site_Logo.08c3a224.png";